import React, { useState, useEffect } from 'react';
import { FaBell } from 'react-icons/fa';
import useNotificationListener from '../../hooks/useNotificationListener';
import { useSelector } from 'react-redux';
import axios from 'axios';
import toast from 'react-hot-toast';
import { useSocket } from '../../contexts/NotificationSocketProvider';
import './_notificationBell.scss';

const NotificationBell = ({ onChatOpen }) => {
  const user = useSelector((state) => state.auth.user);
  const [unread, setUnread] = useState(0);
  const [notifications, setNotifications] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const socketRef = useSocket();
  const socket = socketRef?.current;

  // Friend request notification handler
  useNotificationListener((data) => {
    setUnread((prev) => prev + 1);
    setNotifications((prev) => [...prev, data]);
  });

  // Chat message via socket
  useEffect(() => {
    if (!socket || !user?.user?.id) return;

    const handleIncomingChat = (msg) => {
      const currentChatId = localStorage.getItem("currentChatId");
      const combinedChatId = [msg.from, user.user.id].sort().join("_");

      if (combinedChatId !== currentChatId) {
        setUnread((prev) => prev + 1);
        setNotifications((prev) => [
          ...prev,
          {
            type: "CHAT_MESSAGE",
            from: msg.username,
            userId: msg.from,
          },
        ]);

        toast(`💬 Message from ${msg.username}`, { icon: '📨' });
      }
    };

    socket.on('chatMessage', handleIncomingChat);
    return () => socket.off('chatMessage', handleIncomingChat);
  }, [socket, user]);

  const handleToggleDropdown = () => {
    setDropdownOpen((prev) => {
      if (!prev) setUnread(0);
      return !prev;
    });
  };

  const handleAccept = async (userId) => {
    try {
      const response = await axios.post(
        `https://book-lovers-4592.onrender.com/users/${userId}/acceptFriend`,
        {},
        { headers: { Authorization: `Bearer ${user.token}` } }
      );
      toast.success(response.data.message);
      setNotifications((prev) => prev.filter((n) => n.userId !== userId));
      window.dispatchEvent(new CustomEvent('friendListUpdated'));
    } catch (err) {
      console.error('Accept error:', err);
      toast.error('Failed to accept friend request');
    }
  };

  const handleDecline = (userId) => {
    console.log(`❌ Decline friend from: ${userId}`);
    setNotifications((prev) => prev.filter((n) => n.userId !== userId));
  };

  const handleOpenChatNotification = (userId, username) => {
    if (onChatOpen) {
      onChatOpen(userId, username);
      setDropdownOpen(false); // Close notification dropdown
    }
  };

  return (
    <div className="notification-bell-wrapper">
      <div className="notification-bell" onClick={handleToggleDropdown}>
        <FaBell size={20} />
        {unread > 0 && <span className="badge">{unread}</span>}
      </div>

      {dropdownOpen && (
        <div className="notification-dropdown">
          {notifications.length === 0 ? (
            <p>No notifications</p>
          ) : (
            notifications.map((n, i) => (
              <div key={i} className="notification-item">
                {n.type === 'FRIEND_REQUEST' && (
                  <>
                    <p>👥 Friend request from <strong>{n.from}</strong></p>
                    <button onClick={() => handleAccept(n.userId)}>Accept</button>
                    <button onClick={() => handleDecline(n.userId)}>Decline</button>
                  </>
                )}
                {n.type === 'CHAT_MESSAGE' && (
                  <p
                    className="chat-notification"
                    onClick={() => {
                      if (onChatOpen) {
                        onChatOpen({
                          _id: n.userId,
                          username: n.from,
                        });
                      }

                      // 🧼 Remove this notification after clicking
                      setNotifications((prev) => prev.filter((_, index) => index !== i));
                    }}
                    style={{ cursor: 'pointer' }}
                  >
                    💬 New message from <strong>{n.from}</strong>
                  </p>
                )}

              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
};

export default NotificationBell;
